import { Navigate, useNavigate } from 'react-router-dom';
import { BoxHoverCursor, ColumnBoxFlexFullWidth, FlexBox } from '../common/boxes';
import { TEXTS } from '../../core/texts';
import { Box, Typography, useTheme } from '@mui/material';
import { ImageBox } from '../common/ImageBox';
import React, { useCallback, useEffect, useState } from 'react';
import { BACKGROUND_IMG_PATH, LOGO_PATH } from '../../core/variables';
import { AUTH_PATH, DASHBOARD_PATH } from '../../router/paths';
import AuthRouter from '../../router/AuthRouter';
import { useAuthState } from '../../+state/useAuthState';

const Auth = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useAuthState();
  const [navigateToDashboard, setNavigateToDashboard] = useState(false);

  const onClickLogoHandler = useCallback(() => {
    navigate(AUTH_PATH);
  }, [navigate]);

  useEffect(() => {
    if (user) {
      setNavigateToDashboard(true);
    }
  }, [user]);

  return (
    <ColumnBoxFlexFullWidth sx={{
      height: `100vh`,
      width: '100vw',
      overflowX: 'hidden',
      justifyContent: { mobile: 'initial', laptop: 'space-between' },
      background: {
        mobile: theme.palette.primary.light,
        laptop: `url(${BACKGROUND_IMG_PATH})`,
      },
      backgroundSize: { laptop: 'cover' },
      backgroundRepeat: { laptop: 'no-repeat' },
      backgroundPosition: { laptop: 'right' },
    }}>

      <BoxHoverCursor
        position={'relative'} display={'flex'} justifyContent={{ mobile: 'center', tablet: 'flex-start' }}
        onClick={onClickLogoHandler}
      >
        <ImageBox p={3} width={{ mobile: 320, tablet: 400 }} src={LOGO_PATH} alt="Gigs Remote Logo"/>
      </BoxHoverCursor>

      <FlexBox
        p={{ mobile: 2, laptop: theme.spacing(0, 2, 0, 0) }}
        height={'100%'}
        flexDirection={{ mobile: 'column', laptop: 'row' }}
        alignItems={'center'}
      >
        <Box maxWidth={{ mobile: '100%', tablet: 600 }} mr={{ mobile: 0, laptop: 5 }} sx={{
          background: { mobile: 'initial', laptop: 'rgba(255, 255, 255, .6)' },
          borderRadius: theme.spacing(0, 2, 2, 0),
          padding: theme.spacing(2, 0, 2, 2)
        }}>
          <Typography variant={'h1'}>{TEXTS.AUTH_TITLE}</Typography>
        </Box>

        <Box maxWidth={500} boxShadow={theme.shadows[2]} width={'100%'} p={3} borderRadius={8} position={'relative'}
             my={{ mobile: 4, laptop: 0 }}
             sx={{
               background: '#fff',
             }}
        >
          <AuthRouter/>
        </Box>

      </FlexBox>
      {
        navigateToDashboard &&
        <Navigate to={DASHBOARD_PATH}/>
      }
    </ColumnBoxFlexFullWidth>

  );
};
export default Auth;